export default "__VITE_ASSET__L1sGKAbO__"